import { Route, Routes } from "react-router-dom";
import Login from "./components/Login/Login";
import ForgotPassword from "./components/Login/FogotPassword";
import EmailVerify from "./components/Login/EmailVerify";
import PageNotFound from "./components/PageNotFound";
import LetStart from "./components/Login/LetStart";
import RouteGuard from "./RouteGuard";
import ReSetPassword from "./components/Login/ResetPassword";
import FirstTimeChangePassword from "./components/Login/ChangePassword";
import ReviewForm from "./components/ClientForm/Form/ReviewForm";
import FieldList from "./components/Fields/FieldList";
import CountryList from "./components/CountryList/CountryList";
import EditCountry from "./components/CountryList/EditCountry";
import AddCountry from "./components/CountryList/AddCountry";
import Settings from "./components/Settings/Settings";
import Notifications from "./components/Notifications/Notifications";
import MasterDatabase from "./components/MasterDatabase/MasterDatabase";
import ActivityLog from "./components/ActivityLog/ActivityLog";
import OnboardForm from "./components/ClientForm/Form/OnboardForm";
import ClientList from "./components/ClientList/ClientList";
import ClientOnboardForm from "./components/ClientList/ClientOnboardForm";
import Dashboard from "./components/AllDashboard/Dashboard";
import OPSDashboard from "./components/AllDashboard/OPSDashboard";
import FinanceDashboard from "./components/AllDashboard/FinanceDashboard";
import UpdateClientForm from "./components/ClientList/UpdateClientForm";
import AllRecords from "./components/AllRecords/AllRecords";
import ClientCustomer from "./components/ClientCustomer/ClientCustomer";
import EmployeeList from "./components/AllDashboard/EmployeeList";
import RoleList from "./components/Roles/RoleList";
import EditRolePermissions from "./components/Roles/EditRolePermissions";
import UserList from "./components/Users/UserList";
import AddUser from "./components/Users/AddUser";
import Inbox from "./components/Inbox/Inbox";
import Reports from "./components/Reports/Reports";
import MclGenerator from "./components/MclGenerator/MclGenerator";

// userType 3 = employee
// userType 2 = Manager
// userType 1 = Admin
// userType 4 = Finance

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<LetStart />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<EmailVerify />} />
      <Route path="/otp-verify" element={<EmailVerify />} />
      <Route path="/reset-password" element={<ReSetPassword />} />
      <Route path="/changepassword" element={<FirstTimeChangePassword />} />

      <Route
        path="dashboard"
        element={
          <RouteGuard element={<Dashboard />} allowedUserTypes={["1", "2", "3"]} />
        }
      />

      <Route
        path="notification"
        element={
          <RouteGuard
            element={<Notifications />}
            allowedUserTypes={["1", "2", "3"]}
          />
        }
      />

      <Route
        path="dashboard-e"
        element={
          <RouteGuard element={<OPSDashboard />} allowedUserTypes={["3"]} />
        }
      />

      <Route
        path="dashboard-f"
        element={
          <RouteGuard element={<FinanceDashboard />} allowedUserTypes={["4"]} />
        }
      />

      <Route
        path="fields"
        element={
          <RouteGuard
            element={<FieldList />}
            allowedUserTypes={["1", "2", "3"]}
            module="fields"
          />
        }
      />

      <Route
        path="countryList"
        element={
          <RouteGuard
            element={<CountryList />}
            allowedUserTypes={["1", "2", "3"]}
            module="country_list"
          />
        }
      />

      <Route
        path="EditCountry"
        element={
          <RouteGuard
            element={<EditCountry />}
            allowedUserTypes={["1", "2", "3"]}
            module="country_list"
          />
        }
      />

      <Route
        path="AddCountry"
        element={
          <RouteGuard
            element={<AddCountry />}
            allowedUserTypes={["1", "2", "3"]}
            module="country_list"
          />
        }
      />

      <Route
        path="roles"
        element={<RouteGuard element={<RoleList />} allowedUserTypes={["1"]} module="roles" />}
      />

      <Route
        path="edit-role-permissions"
        element={<RouteGuard element={<EditRolePermissions />} allowedUserTypes={["1"]} module="roles" />}
      />

      <Route
        path="users"
        element={<RouteGuard element={<UserList />} allowedUserTypes={["1"]} module="users" />}
      />

      <Route
        path="add-user"
        element={<RouteGuard element={<AddUser />} allowedUserTypes={["1"]} module="users" />}
      />

      <Route
        path="reports"
        element={
          <RouteGuard element={<Reports />} allowedUserTypes={["1", "2", "3", "4"]} module="reports" />
        }
      />

      <Route
        path="mcl-generator"
        element={
          <RouteGuard element={<MclGenerator />} allowedUserTypes={["1", "5"]} module="mcl_generator" />
        }
      />

      {/* <Route
        path="allRecords"
        element={
          <RouteGuard
            element={<AllRecords />}
            allowedUserTypes={["1", "2", "4"]}
          />
        }
      /> */}

      <Route path="allRecords" element={<AllRecords />} />
      <Route path="clientCustomer" element={<ClientCustomer />} />

      <Route
        path="masterDatabase"
        element={
          <RouteGuard
            element={<MasterDatabase />}
            allowedUserTypes={["1", "2", "3"]}
            module="directory"
          />
        }
      />

      <Route
        path="clientList"
        element={
          <RouteGuard element={<ClientList />} allowedUserTypes={["1", "4"]} module="client_list" />
        }
      />

      <Route
        path="client-onboard-form"
        element={
          <RouteGuard
            element={<ClientOnboardForm />}
            allowedUserTypes={["1", "4"]}
            module="client_list"
          />
        }
      />

      <Route
        path="update-form"
        element={
          <RouteGuard
            element={<UpdateClientForm />}
            allowedUserTypes={["1", "4"]}
            module="client_list"
          />
        }
      />

      <Route
        path="settings"
        element={
          <RouteGuard
            element={<Settings />}
            allowedUserTypes={["1", "2", "3", "4"]}
          />
        }
      />

      <Route
        path="activityLog"
        element={
          <RouteGuard
            element={<ActivityLog />}
            allowedUserTypes={["1", "2", "3", "4"]}
            module="activity_log"
          />
        }
      />

      <Route
        path="inbox"
        element={
          <RouteGuard
            element={<Inbox />}
            allowedUserTypes={["1"]}
            module="inbox"
          />
        }
      />

      <Route path="/employee-list" element={<EmployeeList />} />

      <Route path="/onboardForm" element={<OnboardForm />} />
      <Route path="/reviewForm" element={<ReviewForm />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Routing;
